import { useQuery } from "@apollo/client";
import { gql } from "@/__generated__";

export const GET_PROVIDER = gql(`
  query GetProviderName {
    provider {
      providerId
      providerName
    }
  }
`);

export function useProviderName(): string | null {
  const { loading, data, error } = useQuery(GET_PROVIDER, {
    fetchPolicy: "no-cache",
  });

  if (loading || error || !data?.provider) {
    return null;
  }

  return data.provider.providerName;
}
